import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-content">
        <h1>Политика конфиденциальности</h1>
        <p className="subtitle">(обработка персональных данных)</p>
        
        <section>
          <h2>1. Общие положения</h2>
          <ul>
            <li>Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей в соответствии с Федеральным законом РФ №152-ФЗ «О персональных данных».</li>
            <li>Используя сайт/сервис, пользователь подтверждает согласие на обработку персональных данных в соответствии с Политикой.</li>
          </ul>
        </section>

        <section>
          <h2>2. Персональные данные, которые обрабатываются</h2>
          <p>Мы можем собирать:</p>
          <ul>
            <li>ФИО</li>
            <li>номер телефона</li>
            <li>email</li>
            <li>данные аккаунта (логин, ID)</li>
            <li>платежные данные (маскированно, без хранения реквизитов, если используется сторонний провайдер)</li>
            <li>технические данные: IP, cookies, данные браузера, данные об устройстве</li>
            <li>история действий пользователя в сервисе</li>
          </ul>
        </section>

        <section>
          <h2>3. Цели обработки персональных данных</h2>
          <p>Данные используются для:</p>
          <ul>
            <li>регистрации пользователя и обеспечения доступа к сервису</li>
            <li>связи с пользователем</li>
            <li>исполнения договоров и оказания услуг</li>
            <li>обработки запросов и поддержки</li>
            <li>аналитики, улучшения продукта, персонализации интерфейса</li>
            <li>маркетинговых коммуникаций (при отдельном согласии)</li>
            <li>соблюдения требований законодательства РФ</li>
          </ul>
        </section>

        <section>
          <h2>4. Правовые основания обработки</h2>
          <ul>
            <li>согласие пользователя</li>
            <li>исполнение договора/оферты</li>
            <li>выполнение обязанностей, предусмотренных законодательством РФ</li>
            <li>защита прав и законных интересов компании</li>
          </ul>
        </section>

        <section>
          <h2>5. Передача персональных данных третьим лицам</h2>
          <p>Персональные данные могут передаваться:</p>
          <ul>
            <li>подрядчикам, обеспечивающим техническое функционирование сервиса (хостинг, почтовые сервисы, платёжные провайдеры)</li>
            <li>партнерам при необходимости исполнения услуг</li>
            <li>государственным органам по законному запросу</li>
          </ul>
          <p>Передача осуществляется только в пределах целей обработки и с соблюдением требований 152-ФЗ.</p>
        </section>

        <section>
          <h2>6. Хранение и защита данных</h2>
          <ul>
            <li>Данные хранятся на серверах на территории РФ или у поставщиков, обеспечивающих соблюдение требований законодательства РФ.</li>
            <li>Используются организационные и технические меры защиты: шифрование, резервирование, ограничение доступа по ролям, журналирование действий.</li>
            <li>Срок хранения — до достижения целей обработки либо до отзыва согласия, если нет иных правовых оснований для хранения.</li>
          </ul>
        </section>

        <section>
          <h2>7. Права пользователя</h2>
          <p>Пользователь имеет право:</p>
          <ul>
            <li>получать информацию об обработке своих данных</li>
            <li>требовать уточнения данных</li>
            <li>требовать блокировки или удаления данных</li>
            <li>отзывать согласие на обработку</li>
            <li>ограничивать обработку</li>
          </ul>
          <p>Для реализации прав необходимо направить запрос на email оператора.</p>
        </section>

        <section>
          <h2>8. Cookies и технические данные</h2>
          <p>Сервис использует cookies для:</p>
          <ul>
            <li>авторизации</li>
            <li>персонализации</li>
            <li>аналитики и статистики</li>
          </ul>
          <p>Пользователь может отключить cookies в настройках браузера, что может ограничить работу сервиса.</p>
        </section>

        <section>
          <h2>9. Изменение Политики</h2>
          <p>Компания может обновлять Политику. Новая версия вступает в силу с момента публикации на сайте.</p>
        </section>

        <div className="privacy-footer">
          <Link to="/" className="back-link">Вернуться на главную</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
